export default __webpack_public_path__ + "53b4a27923aecddb4d2ce00bfecd468e.png";